export const createDataDogQuery = (customerId: string, referenceId: string, serviceProviderTripId: string, fromTs?: number, toTs?: number) => {
  const env = process.env.REACT_APP_STAGE === 'local' ? 'dev' : process.env.REACT_APP_STAGE;

  const url = 'https://vwfs-du-central.datadoghq.eu/logs?cols=service%2C%40http.url_details.path&'

  const query =
    `env:${env} service:stm-billing-service ` +
    `(`+
      `(@meta.req.body.detail.data.id:${referenceId} OR @meta.req.body.detail.data.serviceProviderTripId:${serviceProviderTripId}) OR ` +
      `(@meta.res.body.data.referenceId:${referenceId} OR @meta.req.params.referenceId:${referenceId}) `+
    `)`;

  let uriQuery = `query=${encodeURIComponent(query)}&live=false`;

  if (fromTs) {
    uriQuery += `&from_ts=${fromTs}`
  }

  if (toTs)
    uriQuery += `&to_ts=${toTs}`

  return url + uriQuery;
}
